import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TemplateListComponent } from './template-list/template-list.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { TemplateAddUpdComponent } from './template-add-upd/template-add-upd.component';


const routes: Routes = [
    { path: 'template-list', component: TemplateListComponent, canActivate: [AuthGuard] },
    { path: 'template', component: TemplateAddUpdComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TemplateRoutingModule { }
